<template>
  <div class="sender-identifier">
    <profile-picture
      class="profile-picture"
      :profilePicture="contact ? contact.profilePicture : undefined"
    />
    <p>{{ contactFullName }}</p>
  </div>
</template>
<script>
import ProfilePicture from "../../UI/ListItems/ListItemComponents/ProfilePicture.vue";

export default {
  computed: {
    contactFullName() {
      if (this.contact) {
        return `${this.contact.given_name} ${this.contact.family_name}`;
      } else {
        return "";
      }
    },
    isCurrentUser() {
      return this.contactKey.userId === this.$store.state.user.userId;
    },
  },
  components: {
    ProfilePicture,
  },
  props: ["contact"],
};
</script>
<style scoped>
.profile-picture {
  height: 20px;
  width: 20px;
  margin: 0 10px;
}

.sender-identifier {
  width: fit-content;
  display: flex;
  align-items: center;
}

.current-user {
  flex-direction: row-reverse;
  margin-left: auto;
}
</style>
